import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { LayoutTemplate, Loader2, Check } from 'lucide-react';
import { Button } from '../ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
import { API_CP, dejaPresent, erreur, nouveauPoint, themeDe } from './constantes';

const versPoints = (modele) => modele.map((m) => nouveauPoint(m.titre, m.details, m.cle));

// Ajoute les points absents avant « Questions diverses » s'il existe déjà
const completer = (points, modele) => {
  const ajout = versPoints(modele.filter((m) => !dejaPresent(points, m)));
  const fin = points.findIndex((p) => themeDe(p) === 'questions_diverses');
  const pos = fin === -1 ? points.length : fin;
  return [...points.slice(0, pos), ...ajout, ...points.slice(pos)];
};

const ListeModele = ({ modele, points }) => (
    <ol className="max-h-64 space-y-1 overflow-y-auto rounded-xl bg-slate-50 p-3 text-xs" data-testid="cp-modele-fisl-liste">
      {modele.map((m, k) => {
        const ok = dejaPresent(points, m);
        return (
          <li key={m.cle} className={`flex items-start gap-2 ${ok ? 'text-slate-400' : 'text-slate-700'}`}>
            <span className="w-4 shrink-0 font-semibold">{k + 1}.</span><span className="flex-1">{m.titre}</span>
            {ok && <Check className="h-3.5 w-3.5 shrink-0 text-emerald-600" />}
          </li>
        );
      })}
    </ol>
);

export const BoutonModeleFisl = ({ annee, points, onChange }) => {
  const [modele, setModele] = useState(null);
  const [charge, setCharge] = useState(false);
  const appliquer = (liste, msg) => { onChange(liste); toast.success(`${msg} : relisez puis enregistrez l'ordre du jour`); setModele(null); };
  const ouvrir = async () => {
    setCharge(true);
    try {
      const { data } = await axios.get(`${API_CP(annee)}/modele-fisl`);
      if (points.length) setModele(data); else appliquer(versPoints(data), `${data.length} points du modèle FISL ajoutés`);
    } catch (e) { erreur(e, 'Modèle FISL indisponible'); } finally { setCharge(false); }
  };
  const manquants = modele ? completer(points, modele).length - points.length : 0;

  return (
    <>
      <Button variant="outline" onClick={ouvrir} disabled={charge} className="border-[#8DC63F] text-[#0F172A] hover:bg-[#8DC63F]/10" data-testid="cp-odj-modele-fisl">
        {charge ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <LayoutTemplate className="mr-2 h-4 w-4 text-[#6FA22E]" />} Modèle FISL (12 points)
      </Button>
      <AlertDialog open={!!modele} onOpenChange={(o) => !o && setModele(null)}>
        <AlertDialogContent className="max-w-2xl" data-testid="cp-modele-fisl-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Appliquer le modèle FISL ?</AlertDialogTitle>
            <AlertDialogDescription>
              Votre ordre du jour contient déjà {points.length} point(s). Les points déjà présents sont cochés. Remplacer efface les points actuels et leur compte rendu.
            </AlertDialogDescription>
          </AlertDialogHeader>
          {modele && <ListeModele modele={modele} points={points} />}
          <AlertDialogFooter className="gap-2 sm:flex-wrap sm:space-x-0">
            <AlertDialogCancel data-testid="cp-modele-fisl-annuler">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={() => appliquer(versPoints(modele), 'Ordre du jour remplacé par le modèle FISL')} className="border border-slate-300 bg-white text-[#0F172A] hover:bg-slate-50" data-testid="cp-modele-fisl-remplacer">
              Remplacer l'ordre du jour actuel
            </AlertDialogAction>
            <AlertDialogAction disabled={!manquants} onClick={() => appliquer(completer(points, modele), `${manquants} point(s) ajouté(s)`)}
              className="bg-[#0F172A]" data-testid="cp-modele-fisl-completer">
              Ajouter les points manquants ({manquants})
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
